
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
import { BarChart } from "lucide-react";
import CashflowChart from '../charts/CashflowChart';

const ForecastResultsCard: React.FC = () => {
  return (
    <Card className="lg:col-span-2">
      <CardHeader>
        <CardTitle className="flex items-center">
          <BarChart className="h-5 w-5 mr-2" />
          Cashflow Forecast Results
        </CardTitle>
        <CardDescription>
          Projected cashflows based on selected model parameters
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CashflowChart />
        
        <div className="mt-6">
          <h4 className="text-sm font-medium mb-2">Override Conditionalities</h4>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Condition Type</TableHead>
                <TableHead>Threshold</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>Liquidity Shortfall</TableCell>
                <TableCell>₹50 Cr</TableCell>
                <TableCell>Trigger contingency funding</TableCell>
                <TableCell className="text-amber-500">Monitoring</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Interest Rate Shock</TableCell>
                <TableCell>200 bps</TableCell>
                <TableCell>Rebalance fixed/floating assets</TableCell>
                <TableCell className="text-green-500">Inactive</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Deposit Flight</TableCell>
                <TableCell>15% in 30 days</TableCell>
                <TableCell>Activate high-yield deposits</TableCell>
                <TableCell className="text-green-500">Inactive</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ForecastResultsCard;
